import React from 'react'
import { connect } from "react-redux";
import PowerbiEmbedded from "react-powerbi";
import {
    fetchReports
} from '../../../../store/actions/reportsAction'

class ChronicConditions extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            reportID: '5e9e5659-625f-44b1-8c44-54e76d33fb54',
            user: this.props.user,
            token: {}
        }
        const {user, reportID} = this.state;
        user && this.props.fetchReports({reportID, user});
    }

    componentWillReceiveProps(nextProps, prevProps){
        if(nextProps.token){
            if(nextProps.token !== this.state.token){
                this.setState({
                    token: nextProps.token,
                    user: nextProps.user
                });
                
            }
        }
    }

    render(){
        const { token, user } = this.state;
        const { reportID } = this.state;
        return(
            <div style={{width: '100%', padding: 0, height: 'calc( 100vh - 60px )'}}>
                {token && <PowerbiEmbedded
                    id={reportID}
                    userId={ user.userId }
                    embedUrl={token.embedUrl}
                    accessToken={token.accessToken}
                    filterPaneEnabled={true}
                    navContentPaneEnabled={true}
                    tokenType='Embed'
                    width="100%"
                    height="100%"
                    onEmbedded={this.onEmbedded}
                />}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    token: state.token.token,
    user: state.auth.user
})

export default connect(mapStateToProps, {
    fetchReports
})(ChronicConditions);